import React from 'react'
import PropTypes from 'prop-types'
import useColumnLocation from '../hooks/use-column-location'
import ColumnHead from '../layouts/ColumnHead'
import ColumnCell from '../layouts/ColumnCell'
import ColumnFooter from '../layouts/ColumnFooter'

function Column (props) {
  const location = useColumnLocation()

  if (location === 'head') {
    return (
      <ColumnHead
        key={props.name || 'undefined'}
        name={props.name}
        label={props.label}
        sortable={props.sortable}
        sortSlug={props.sortSlug}
        sortName={props.sortName}
        className={props.className}
        alignment={props.alignment}
        title={props.headerTitle}
        onClick={props.headerClicked}
      />
    )
  }

  if (location === 'footer') {
    return (
      <ColumnFooter
        {...props}
        alignment={props.alignment}
        name={props.name}
        display={props.display}
        content={props.footer}
        aggregate={props.aggregate}
        className={props.className}
      />
    )
  }

  return (
    <ColumnCell
      {...props}
      name={props.name}
      enum={props.enum}
      display={props.display}
      alignment={props.alignment}
      rowClass={props.rowClass}
      className={props.className}
    >
      {props.children}
    </ColumnCell>
  )
}

Column.defaultProps = {
  name: null,
  alignment: 'left',
  rowClass: '',
  className: '',
  display: null,
  footer: null,
  aggregate: null
}

Column.propTypes = {
  alignment: PropTypes.string,
  className: PropTypes.string,
  display: PropTypes.any,
  name: PropTypes.string,
  headerTitle: PropTypes.string,
  headerClicked: PropTypes.func,
  rowClass: PropTypes.string,
  sortName: PropTypes.string,
  sortSlug: PropTypes.string,
  sortable: PropTypes.bool,
  footer: PropTypes.node,
  aggregate: PropTypes.oneOfType([PropTypes.func, PropTypes.string])
}

export default Column
